import React, { useState, useEffect } from 'react';
import PanelContext from '../../components/PanelContext/PanelContext';
import Accordion from 'react-bootstrap/Accordion';
import TopicsSemantic from './modules/TopicsSemantic'
import { TopicsSubTopicsProvider } from './context/TopicsSubTopics'
import TopicsFinder from './modules/TopicsFinder';

function LingvoSemantic() {

  return <>
    <PanelContext title="Работа с Интересами">
      <div data-bs-theme="dark">
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header><p style={{'fontWeight': 'bold', margin: 0, padding: 0}}>Генерирование семантического ядра</p></Accordion.Header>
            <Accordion.Body>
              <TopicsSubTopicsProvider>
                  <TopicsSemantic></TopicsSemantic>
              </TopicsSubTopicsProvider>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header><p style={{'fontWeight': 'bold', margin: 0, padding: 0}}>Извлечение интересов из текста</p></Accordion.Header>
            <Accordion.Body>
              <TopicsFinder></TopicsFinder>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </PanelContext>
  </>
}
  
export default LingvoSemantic
